/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';
import { MED_DATE_ONLY_DISPLAY, SHORT_DATETIME_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Grid, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/shared-articles';

type Props = {
  authorNames?: string;
  date: string;
  shareButtonComponent: React.ReactNode;
};

const styles = {
  shareButtonWrapper: css`
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-family: 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    letter-spacing: -0.1px;
  `,
};

const ByLine = ({ authorNames, date, shareButtonComponent }: Props) => (
  <Grid container justifyContent="space-between" alignItems="center">
    <Grid item>
      <Typography2 component="span" variant="bodySecondary">
        {authorNames && (
          <FormattedMessage message={_t('Written by {listOfauthorNames} • ')} listOfauthorNames={authorNames} />
        )}
        <FormattedMessage
          message={_t('Updated on {latestPublishDate}')}
          latestPublishDate={
            <time dateTime={formatDateTimeDisplay(date, SHORT_DATETIME_DISPLAY)}>
              {formatDateTimeDisplay(date, MED_DATE_ONLY_DISPLAY)}
            </time>
          }
        />
      </Typography2>
    </Grid>
    <Grid item css={styles.shareButtonWrapper}>
      {shareButtonComponent}
    </Grid>
  </Grid>
);

export default ByLine;
